import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import NOB from '../../../constants/language-strings';
import styled from 'styled-components';
const ListItemWrapper = styled.li `
  list-style-type: none;
  padding: 5px 0;
  border-bottom: 1px solid #ddd;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;

  &:last-child {
    border-bottom: none;
  }
`;
export const WorkOrderHistoryItem = ({ workOrderHistoryItem }) => {
    return (_jsxs(ListItemWrapper, { children: [_jsx("div", { children: workOrderHistoryItem.time }), _jsx("div", { children: `${NOB.WORKORDER_HISTORY.USER}: ${workOrderHistoryItem.userFullName} (${workOrderHistoryItem.userId})` }), _jsx("div", { children: `${NOB.WORKORDER_HISTORY.STATUS_ID}: ${workOrderHistoryItem.statusId}` }), _jsx("div", { children: `${NOB.WORKORDER_HISTORY.REASON}: ${workOrderHistoryItem.reasonDescription} (${workOrderHistoryItem.reasonKey})` })] }));
};
